import React, { useState } from "react";
import { IconButton, Menu, MenuItem } from "@mui/material";
import Icon from "../components/elements/Icon";
import { Anchor, Button } from "./elements";

export default function DotsMenu({ dots, dropdown }) {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <IconButton
                className="mc-dropdown-toggle"
                onClick={handleClick}
                aria-controls={open ? 'dots-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
            >
                <Icon type={dots} />
            </IconButton>
            <Menu
                id="dots-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                className="mc-dropdown-paper"
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >
                {dropdown?.map((item, index) => (
                    <MenuItem key={index} onClick={() => { item.onClick?.(); handleClose(); }}>
                        {item.path ? (
                            <Anchor
                                href={item.path}
                                icon={item.icon}
                                text={item.text}
                                className="mc-dropdown-menu"
                            />
                        ) : (
                            <span>
                                {item.icon && <Icon type={item.icon} />}
                                {item.text}
                            </span>
                        )}
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
}